import '@scss/style.scss';
import UIkit from 'uikit';
import Icons from 'uikit/dist/js/uikit-icons';
import 'uikit/dist/css/uikit.css';
import './cookies';
import './split-gmap';
import './searchHints';
window.UIkit = UIkit;
UIkit.use(Icons);

const navBtn = document.querySelector('.nav-btn');
const navContainer = document.querySelector('header nav');
const logo = document.querySelector('header .logo');
const body = document.querySelector('body');
const main = document.querySelector('main');
const footer = document.querySelector('footer');

// Menu mobile
const handleMobileNavigation = () => {
    const isOpen = navContainer.classList.contains('open');
    navBtn.setAttribute('aria-expanded', isOpen);
    navContainer.toggleAttribute('inert', !isOpen);
    main.toggleAttribute('inert', isOpen);
    footer.toggleAttribute('inert', isOpen);
    logo.toggleAttribute('inert', isOpen);
    navBtn.focus();
  };
  
  const toggleNavigation = () => {
    body.classList.toggle('noscroll');
    navBtn.classList.toggle('active');
    navContainer.classList.toggle('open');
    handleMobileNavigation();
  };
  
  const handleResize = () => {
    const isMobile = window.innerWidth < 1024;
    navBtn.setAttribute('aria-expanded', !isMobile);
    navContainer.toggleAttribute('inert', isMobile);
  
    if (!isMobile) {
      main.removeAttribute('inert');
      footer.removeAttribute('inert');
      body.classList.remove('noscroll');
      navContainer.classList.remove('open');
      navBtn.classList.remove('active');
    }
  };
  
  navBtn.addEventListener('click', toggleNavigation);
  
  document.addEventListener('DOMContentLoaded', () => {
    handleResize();
  });
  
  window.addEventListener('resize', handleResize);
  
// Sticky menu
window.addEventListener("scroll", function() {
    var header = document.querySelector('header');
    if (window.scrollY > 110) 
    {
        header.classList.add("sticky");
        if (header.classList.contains('-other'))
        {
            document.querySelector('main').style.paddingTop = `${header.offsetHeight}px`;
        } 
    } 
    else {
        header.classList.remove("sticky");
        document.querySelector('main').style.paddingTop = '';
    }
  });

//Focus for inputs
const inputs = document.querySelectorAll("input");

inputs.forEach(input => {
    input.addEventListener("focus", function () {
        input.style.borderColor = "#162969";
    });

    input.addEventListener("blur", function () {
        input.style.borderColor = "#F3F3F3";
    });
});

// Custom select
document.addEventListener("DOMContentLoaded", function () {
    const selectBtn = document.getElementById("select-btn");
    const heroSearch = document.querySelector(".hero__search");
    const visitSearch = document.querySelector(".visit__form");
    const findSearch = document.querySelector(".find__form");

    if(selectBtn)
    {
        const selectText = selectBtn.querySelector("p");
        const optionsList = document.getElementById("options-list");
        const options = optionsList.querySelectorAll("li");
        const hiddenInput = document.querySelector(".hiddenInput");
        const arrow = selectBtn.querySelector("img");

        selectBtn.addEventListener("click", function (event) {
            event.stopPropagation();
            optionsList.classList.toggle("hidden");
            arrow.classList.toggle("-rotate");
            selectBtn.classList.toggle("-radius");
        });

        options.forEach(option => {
            option.addEventListener("click", function () {
                selectText.innerText = this.innerText;
                if (this.hasAttribute("data-value")) {
                    hiddenInput.value = this.getAttribute("data-value");
                }
                optionsList.classList.add("hidden");
                arrow.classList.remove("-rotate");
                selectBtn.classList.remove("-radius");
            });
        });

        document.addEventListener("click", function () {
            if (!optionsList.classList.contains("hidden")) { 
                optionsList.classList.add("hidden");
                arrow.classList.remove("-rotate");
                selectBtn.classList.remove("-radius");
            }
        });
    }

});
// Select function for map list
document.addEventListener("DOMContentLoaded", function () {

    const listSearch = document.querySelector(".mapList__content");
    const selectBtn = document.getElementById("select-btn");
    
    if (listSearch)
    {
        const selectText = selectBtn.querySelector("p");
         const optionsList = document.getElementById("options-list");
         const options = optionsList.querySelectorAll("li");
         const places = document.getElementById("places");
         const allCards = document.querySelectorAll(".mapList__tiles");
         const arrow = selectBtn.querySelector("img");
 
 
 
         options.forEach(option => {
             option.addEventListener("click", function () {
                 selectText.innerText = this.innerText;
                 places.value = this.getAttribute("value"); 
                 places.setAttribute("uk-filter-control", this.getAttribute("uk-filter-control") );
             });
         });


        document.getElementById("btn-places").addEventListener("click", function() {
            let inputControl = places.getAttribute("uk-filter-control");
            
            let cards = document.querySelectorAll(inputControl);

            allCards.forEach(card => {
                card.classList.remove('-active');
                setTimeout(() => {
                    card.style.display = "none";
                }, 300);
            });

            cards.forEach(card => {             
                setTimeout(() => {
                    card.style.display = "block";
                }, 300);
                setTimeout(() => {
                    card.classList.add('-active');
                }, 400);
            });  

            
            
        });
    }

});

// Cities dropdown
const itemsCity = document.querySelectorAll(".cities__item");

itemsCity.forEach(item => {
    item.addEventListener("click", function (e) {
        e.stopPropagation();
        const drop = item.querySelector(".cities__drop");

        drop.classList.toggle('open');

    });
});
document.addEventListener("click", function () {
    document.querySelectorAll(".cities__drop.open").forEach(openDrop => {
        openDrop.classList.remove("open");
    });
});

document.addEventListener("DOMContentLoaded", function() {
// Visit form radio function
    const descFlaw = document.getElementById("desc-flaw");
    const chooseServ = document.getElementById("choose-serv");
    const showDesc = document.getElementById("show-desc");
    const showSelect = document.getElementById("show-select");

    function toggleDivs() {
        if (descFlaw.checked) {
            showDesc.classList.remove("hidden");
            showSelect.classList.add("hidden");
        } else {
            showDesc.classList.add("hidden");
            showSelect.classList.remove("hidden");
        }
    }

    if(descFlaw)
    {
        descFlaw.addEventListener("change", toggleDivs);
        chooseServ.addEventListener("change", toggleDivs);

        toggleDivs();
    }

// Stay Eurowworkshop radio dropdown
const moreinfo = document.getElementById("more-info");

function toggleRad()
    {
        if (moreinfo.checked)
        {
            let dropdown = document.querySelector(".stayForm__dropdown");
      
            if (dropdown.style.maxHeight) 
            {
                dropdown.style.maxHeight = null;
            } 
            else 
            {
                dropdown.style.maxHeight = dropdown.scrollHeight + "px";
            }
        }
    }

if (moreinfo)
{

    moreinfo.addEventListener("change", toggleRad);
    toggleRad();
    
}

});


// Dropdown for new input Visit page
const todrop = document.querySelector(".to-drop");

if (todrop)
{
    todrop.addEventListener("click", function () {
        let dropdown = document.querySelector(".dropdown");
      
        if (dropdown.style.maxHeight) {
          dropdown.style.maxHeight = null;
        } else {
          dropdown.style.maxHeight = dropdown.scrollHeight + "px";
        }
      });
}


// Force display for mobile three level
function updateMobileDropdownBehavior() {
  const parents = document.querySelectorAll('.uk-parent');

  parents.forEach(parent => {
    const dropdown = parent.querySelector('.display-mobile');
    const link = parent.querySelector('a');

    if (!dropdown || !link) return;

    if (window.innerWidth <= 1024) {
      if (!dropdown.hasAttribute('data-original-uk-dropdown') && dropdown.hasAttribute('uk-dropdown')) {
        dropdown.setAttribute('data-original-uk-dropdown', dropdown.getAttribute('uk-dropdown'));
      }

      dropdown.removeAttribute('uk-dropdown');
      dropdown.style.display = 'none';

      link.addEventListener('click', forceNavigateOnClick, { once: true });

    } else {

      const originalDropdown = dropdown.getAttribute('data-original-uk-dropdown');
      if (originalDropdown) {
        dropdown.setAttribute('uk-dropdown', originalDropdown);
      }
      dropdown.style.display = '';

      link.removeEventListener('click', forceNavigateOnClick);
    }
  });
}

function forceNavigateOnClick(e) {
  const href = this.getAttribute('href');
  if (href && href !== '#') {
    e.preventDefault();
    e.stopImmediatePropagation();
    window.location.href = href;
  }
}

window.addEventListener('DOMContentLoaded', updateMobileDropdownBehavior);
window.addEventListener('resize', updateMobileDropdownBehavior);